import React, { Component } from "react";
import Select from "react-select";

export default class FilterDropDown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedValue: { label: "ALL", value: 0 },
    };
  }

  handleSelect = (event) => {
    this.props.handleSelect(event.value);
    this.setState({
      selectedValue: event,
    });
  };

  render() {
    return (
      <div
        className="col-lg-3 col-md-6 col-sm-12"
        style={{
          paddingLeft: "0",
          paddingRight: "0",
          marginBottom: "10px",
        }}
      >
        <div>
          <label className="col-sm-12">{this.props.label}</label>
        </div>
        <div className="col-md-10">
          <Select
            options={this.props.dropDownList}
            value={this.state.selectedValue}
            onChange={this.handleSelect}
            className="react-select-container checkValidate"
            classNamePrefix="react-select"
          />
        </div>
      </div>
    );
  }
}
